<template>
    <ul class="navigation-ul d-flex flex-column align-items-start common-vertical-overflow common-scrollbar">
        <li v-for="(menuObj, i) of menuList">
            <router-link v-if="menuObj.is_active == 1" @click="toggleNavigation" :to="menuObj.menu.menu_link" class="navigation-li d-flex align-items-center column-gap-4 textstart">
                <img v-if="menuIconsObj.hasOwnProperty(menuObj.menu.menueng)" :src="require(`@/assets/images/navigationImages/${menuIconsObj[menuObj.menu.menueng]}.svg`)" alt="home">
                <h3 :class="['large-text', 'text-start', {'light-blue-color': CurrentMenuID == menuObj.menuID}]">{{ menuObj.menu.menu }}</h3>
            </router-link>
        </li>
    </ul>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
            menuList: [],
            menuIconsObj: {
                Home: "Home",
                Supporters: "supporters",
                "Issue tracking": "Issue tracking",
                "Door to Door": "Door to Door",
                loan: "loan",
                Mobilisation: "mobilisation",
                survey: "survey",

                "News / Activities": "supporters",
                "Add Organization": "Issue tracking",
                "Add Office": "Door to Door",
                "Add Position": "loan",
                "Add Municipality": "mobilisation",
                "Add City": "survey",

                "Add Region": "supporters",
                "Add Menu to User": "Issue tracking",
                "Add District": "Door to Door",
                "Election": "loan",
                "Add Employee": "supporters",
                "Final Results": "mobilisation",
                "Exit Poll": "supporters",
            },
        }
    },
    computed: {
        ...mapGetters({
            CurrentMenuID: "getCurrentMenuID",
            userInfo: "getUserInfo",
        }), 
    },
    mounted(){
        this.getValidMenus();
    },
    methods: {
        toggleNavigation(){
            this.$store.dispatch("toggleNavigation");
        },
        getValidMenus(){
            this.userInfo.user_menus.forEach((menuObj) => {
                if(menuObj.is_active == 1 && menuObj?.menu?.is_mobile == 0){
                    this.menuList.push(menuObj);
                }
            });
        },
    }
}

</script>
<style scoped>
.navigation-ul{
    row-gap: 1.5em;
    height: 100%;
}
.common-vertical-overflow{
    padding-right: 1.5em;
}
.navigation-li{
    padding: 0.3em 0.2em;
    color: var(--middle-gray);
    font-weight: 600;
    cursor: pointer;
    text-decoration: none
}
.navigation-li h3{
    width: fit-content;
}
.active-menu img{
    fill: var(--light-blue);
}
@media screen and (max-width: 1600px) {
    .navigation-ul.common-scrollbar{
        padding-right: 1em;
    }
}

@media screen and (max-width: 1560px) {
    .common-vertical-overflow{
        padding-right: 2em;
    }
}
</style>